export const timeDefault = {
  defaultAmStart: '08:00',
  defaultAmEnd: '12:00',
  defaultPmStart: '13:00',
  defaultPmEnd: '18:00'
}

export enum ENodeType {
  PORT = 'PORT',
  ICD = 'ICD',
  WAREHOUSE = 'WAREHOUSE',
  DEPOT = 'DEPOT',
  BORDER_GATE = 'BORDER_GATE',
  TOLL_STATION = 'TOLL_STATION'
}
export enum EWarehouseType {
  BONDED = 'BONDED',
  NORMAL = 'NORMAL'
}
export enum ECargoType {
  DRY = 'DRY',
  FROZEN = 'FROZEN',
  MIX = 'MIX'
}
export interface IWaitingTime {
  customer: String
  value: number
  customerName: String
}
interface IPeriodTime {
  AM: Array<Number>
  PM: Array<Number>
}
interface IDaysOfWeek {
  mon: IPeriodTime
  tue: IPeriodTime
  wed: IPeriodTime
  thu: IPeriodTime
  fri: IPeriodTime
  sat: IPeriodTime
  sun: IPeriodTime
}
interface IWorkingTime {
  inTime: IDaysOfWeek
  overTime: IDaysOfWeek
  weekend: IDaysOfWeek
}
interface ITariff {
  inTime: Number
  overTime: Number
  weekend: Number
}
interface ITollStationPrice {
  lt2000KG: Number
  lt4000KG: Number
  lt10000KG: Number
  lt18000KG: Number
  gt18000KG: Number
}
export interface ITollStationInformation {
  priceOnMonth: ITollStationPrice
  priceOnTrip: ITollStationPrice
}
export interface IWarehouseInformation {
  owner: String
  waitingTime: IWaitingTime
  workingTime: IWorkingTime
  wattage: Array<String>
  type: EWarehouseType
  cargoType: ECargoType
  tariff: ITariff
}
export interface INode {
  type: String
  code: String
  name: String
  lat: Number
  lng: Number
  address: String
  addressName: String
  warehouseInformation: IWarehouseInformation
  tollStationInformation: ITollStationInformation
  borderGateInformation: { [key: string]: any }
  loadLimit: Boolean
  axes: Number
  load: Number
  time: Array<Number>
  from: Date
  to: Date
  position: String
  description: String
}

export interface INodeType {
  _id: String
  code: String
  name: String
  businesses: Array<String>
  businessSelected: Array<any>
}

export const rulesAddNodeType = {
  'nodeTypeModule.name': 'required',
  business: 'required'
}

const initValue: any = {
  company: '',
  location: '',
  locationName: '',
  portCode: '',
  address: '',
  hasLoadLimit: false,
  loadLimit: undefined,
  liftingVehicleReceivingForce: [],
  contCategory: [20, 40, 45],
  maximumLoad: undefined,
  typeCommodity: ['NORMAL', 'OVERWEIGHT'],
  goodType: ['SOLID', 'LIQUID', 'GAS'],
  typeReefer: ['NOTREEFER'],
  typeDangerous: ['NOTDANGEROUS'],
  typeFragileGoods: ['NOTFRAGILE'],
  nodeType: '',
  nodeTypeName: '',
  warehouseType: '',
  businesses: {},
  workingTime: {
    mon: [],
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: []
  } as { [key: number]: any },
  holidayWorking: false as Boolean,
  holidayWorkingOverTime: false as Boolean,
  tollStationsPrices: {
    vehicle: {} as { [key: string]: any },
    cont: {} as { [key: number]: any }
  },
  description: ''
} as any

const initEditValue: any = {
  id: '',
  company: '',
  companyName: '',
  location: '',
  locationName: '',
  portCode: '',
  address: '',
  hasLoadLimit: false,
  loadLimit: undefined,
  liftingVehicleReceivingForce: [],
  contCategory: [20, 40, 45],
  maximumLoad: undefined,
  typeCommodity: ['NORMAL'],
  goodType: ['SOLID'],
  typeReefer: ['NOTREEFER'],
  typeDangerous: ['NOTDANGEROUS'],
  typeFragileGoods: ['NOTFRAGILE'],
  nodeType: '',
  nodeTypeName: '',
  warehouseType: '',
  businesses: {},
  workingTime: {
    mon: [],
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: []
  } as { [key: number]: any },
  tollStationsPrices: {
    vehicle: {} as { [key: string]: any },
    cont: {} as { [key: number]: any }
  },
  description: ''
} as any

const initWorkingTime = {
  mon: [],
  tue: [],
  wed: [],
  thu: [],
  fri: [],
  sat: [],
  sun: []
} as { [key: number]: any }

export default {
  initValue,
  initWorkingTime,
  initEditValue
}
